import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'

interface TaskAction extends Action {}

const { onRequest, onSuccess, onFailure } = rootActions.companies.prePublishCompany
function* prePublishCompanySagaTask(payload) {
    try {
        const response = yield axios.put(`/companies/pre-publish/${payload.id}`)
        if (response.success) {
            yield put(onSuccess(response.result))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* prePublishCompanySaga(): any {
    yield takeLatest<TaskAction>(onRequest, prePublishCompanySagaTask)
}

export default prePublishCompanySaga
